import TopSecretLogo from '@/assets/images/0-latelier-top-secret.svg?react';
import { useAnimate } from 'motion/react';
import { useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

export const Div3 = ({ onComplete }: Props) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const enterAnimation = async () => {
      // initial state, instant
      await animate(scope.current, { opacity: 0 }, { duration: 0 });

      // actual animation
      await animate(scope.current, { opacity: 1 }, { duration: 1, ease: 'easeInOut' });

      setTimeout(() => {
        // exit
        void animate('#logo', { opacity: 0 }, { duration: 0.5, ease: 'easeInOut' });
        void animate(scope.current, { scale: 2 }, { duration: 1, ease: 'easeInOut' }).then(onComplete);
      }, 1000);
    };

    void enterAnimation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={scope} className="flex justify-center items-center bg-beige w-[50vw] h-[50vh] p-4 rounded-lg">
      <TopSecretLogo id="logo" />
    </div>
  );
};
